import { TextWithTooltip } from "@components/common/text-with-tooltip";
import { Dialog, Text } from "@flat-ui";
import { useLoggedInUser } from "@hooks/use-logged-in-user";
import { useAppNavigation } from "@router/use-app-navigation";

/**
 * Shows an access denied dialog when the user is logged in but doesn't have permissions to access the admin panel,
 * with the option to log out or go back to the dashboard.
 */
export function AccessDeniedPage(): React.JSX.Element {
  const { navigateToWorkspacePage, navigateToLogoutPage } = useAppNavigation();
  const { currentUser } = useLoggedInUser();

  const userEmail = currentUser?.email || "Unknown";

  return (
    <Dialog
      open={true}
      title={<Text variant="heading24">Access Denied</Text>}
      onConfirm={navigateToLogoutPage}
      confirmText="Log Out"
      cancelText="Go to Dashboard"
      onCancel={navigateToWorkspacePage}
      size="l"
    >
      <>
        <Text variant="bodyL">
          <TextWithTooltip
            prefix="You are currently logged in as"
            text={userEmail}
            suffix=", and don't have permission to access the admin panel."
          />
        </Text>
        <Text variant="bodyL" sx={{ mt: 2 }}>
          If you think this is a mistake, please contact the administrator to
          grant you access, or log in again with an account that has access to
          the admin panel.
        </Text>
      </>
    </Dialog>
  );
}
